<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
// https://stackoverflow.com/a/51170320/76535
import axios from "axios";
import store from "./store/index";
import router from "./router";

export default {
  name: "App",
  data() {
    return {};
  },
  created: function () {
    axios.interceptors.response.use(undefined, (err) => {
      if (err && err.message === 'Network Error') {
        this.$bus.$emit('network-error');
      } else {
        this.$bus.$emit('network-ok');
      }

      return new Promise((resolve, reject) => {
        if (
          err.response &&
          store.getters.getIsFacilitator &&
          (err.response.status === 403 || err.response.status === 401) &&
          err.config &&
          // eslint-disable-next-line no-underscore-dangle
          !err.config.__isRetryRequest
        ) {
          store.dispatch("logout");
          router.push("/admin/login/expired/1");
        } else {
          throw err;
        }
      });
    });
  },
};
</script>
